"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Divider = function Divider(props) {
  var _a, _b;
  var text = props.text,
    _c = props.type,
    type = _c === void 0 ? 'horizontal' : _c,
    _d = props.textAlignment,
    textAlignment = _d === void 0 ? 'center' : _d,
    textColor = props.textColor,
    textGap = props.textGap,
    children = props.children,
    hideLeftLine = props.hideLeftLine,
    hideRightLine = props.hideRightLine,
    width = props.width,
    _e = props.height,
    height = _e === void 0 ? 12 : _e,
    color = props.color,
    fill = props.fill,
    _f = props.gap,
    gap = _f === void 0 ? 12 : _f,
    style = props.style;
  var label = text || children;
  var cssObj = {};
  var gapValue = typeof gap === 'number' ? "".concat(gap, "px") : gap;
  switch (type) {
    case 'vertical':
      cssObj = __assign({
        fontSize: typeof height === 'number' ? Math.ceil(height / 0.9) : height,
        color: color,
        marginLeft: gapValue,
        marginRight: gapValue
      }, style);
      break;
    case 'horizontal':
      cssObj = __assign((_a = {
        width: width,
        color: color,
        background: fill,
        marginTop: gapValue,
        marginBottom: gapValue
      }, _a['--divider-text-gap'] = typeof textGap === 'number' ? "".concat(textGap, "px") : textGap, _a), style);
      break;
    case 'space':
    case 'full-space':
      cssObj = __assign({}, style);
      break;
  }
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-divider', "odc-divider-".concat(type), (_b = {
      'odc-divider-with-text': label
    }, _b["odc-divider-with-text-".concat(textAlignment)] = label, _b['hide-left'] = hideLeftLine, _b['hide-right'] = hideRightLine, _b)),
    supportAllEvents: true
  }, Divider), {
    style: cssObj
  }), label ? react_1["default"].createElement("span", {
    className: "odc-divider-text",
    style: {
      color: textColor
    }
  }, label) : null);
};
Divider.displayName = 'Divider';
(0, spaui_utils_1.setComponentMark)(Divider, info_1["default"]);
exports["default"] = react_1["default"].memo(Divider);